import React from 'react';

import GridOnIcon from '@mui/icons-material/GridOn';
import NumbersIcon from '@mui/icons-material/Numbers';
import { SxProps, Theme } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';

type Mode = 'column' | 'const';
type Props = {
  mode: Mode;
  onChange: (mode: Mode) => void;
  sx?: SxProps<Theme>;
};

const ModeButtonGroup: React.FC<Props> = ({ mode, onChange, sx }) => {
  const handleToggle = (_: React.MouseEvent<HTMLElement>, newMode: Mode | null) => {
    if (newMode) onChange(newMode);
  };

  return (
    <ToggleButtonGroup
      color="primary"
      value={mode}
      exclusive
      onChange={handleToggle}
      size="small"
      sx={sx}
    >
      <Tooltip title="Column name">
        <ToggleButton value="column" selected={mode === 'column'}>
          <GridOnIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Value">
        <ToggleButton value="const" selected={mode === 'const'}>
          <NumbersIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default ModeButtonGroup;
